export const BulkUploadPatientsTable = ({
  title,
  data,
  headerClass,
  rowKey = "id",
}) => {
  if (!data || data.length === 0) return null;

  const hasError = data.some((item) => item.error);

  const renderValue = (value) => {
    if (value === null || value === undefined) return "";
    if (typeof value === "object") {
      return value.description || value.name || JSON.stringify(value);
    }
    return String(value);
  };

  const columns = [
    {
      key: "#",
      label: hasError ? "Fila" : "#",
      render: (item, index) => (hasError ? item["#"] || item.row : index + 1),
    },
    { key: "firstName", label: "Nombres" },
    { key: "lastName", label: "Apellidos" },
    { key: "documentType", label: "Tipo Doc" },
    { key: "document", label: "Documento" },
    { key: "gender", label: "Género" },
    { key: "birthDate", label: "F. Nacimiento" },
    { key: "ratePlan", label: "Plan" },
    { key: "ethnicity", label: "Etnia" },
    { key: "maritalStatus", label: "Estado Civil" },
    { key: "country", label: "País" },
    { key: "department", label: "Departamento" },
    { key: "city", label: "Ciudad" },
    { key: "address", label: "Dirección" },
    { key: "phoneNumber", label: "Teléfono" },
    { key: "email", label: "Email" },
    ...(hasError ? [{ key: "error", label: "Error" }] : []),
  ];

  return (
    <div
      className="table-responsive mt-2"
      style={{ maxHeight: "300px", overflowY: "auto", overflowX: "auto" }}
    >
      <table className="table table-sm table-striped">
        <thead className={`${headerClass} sticky-top`} style={{ zIndex: 1 }}>
          <tr>
            <th colSpan={columns.length} style={{ padding: "0.25rem" }}>
              {title}
            </th>
          </tr>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                style={{
                  minWidth: col.key === "#" ? "20px" : "100px",
                  padding: "0.25rem",
                  whiteSpace: "nowrap",
                }}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={item[rowKey] || index}>
              {columns.map((col) => (
                <td
                  key={col.key}
                  className={col.key === "#" ? "fw-bold" : ""}
                  style={{ padding: "0.25rem", whiteSpace: "nowrap" }}
                >
                  {col.render
                    ? col.render(item, index)
                    : renderValue(item[col.key])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
